import { useIdentityStore } from '~/store/identity'

export function usePasskeyEnabled() {
  return !!window?.PublicKeyCredential && !useIdentityStore(useNuxtApp().$pinia).onlySsoSupported
}
